import { api } from './api';

export interface TransferenciaDetalle {
  id: number;
  transferenciaId: number;
  productoId: number;
  cantidadSolicitada: number;
  cantidadEnviada: number;
  cantidadRecibida: number;
  costoUnitario: number;
  producto?: {
    id: number;
    name: string;
    sku?: string;
    unidadMedida: string;
  };
}

export interface Transferencia {
  id: number;
  sucursalOrigenId: number;
  sucursalDestinoId: number;
  estado: 'pendiente' | 'en_transito' | 'recibida' | 'cancelada';
  usuarioOrigenId: number;
  usuarioDestinoId?: number;
  fechaEnvio?: string;
  fechaRecepcion?: string;
  notas?: string;
  sucursalOrigen?: {
    id: number;
    name: string;
  };
  sucursalDestino?: {
    id: number;
    name: string;
  };
  usuarioOrigen?: {
    id: number;
    name: string;
    email: string;
  };
  usuarioDestino?: {
    id: number;
    name: string;
    email: string;
  };
  detalles?: TransferenciaDetalle[];
  createdAt?: string;
  updatedAt?: string;
}

export interface TransferenciaCreate {
  sucursalOrigenId: number;
  sucursalDestinoId: number;
  notas?: string;
  detalles: Array<{
    productoId: number;
    cantidadSolicitada: number;
  }>;
}

export interface TransferenciaEnvio {
  detalles: Array<{
    productoId: number;
    cantidadEnviada: number;
  }>;
}

export interface TransferenciaRecepcion {
  detalles: Array<{
    productoId: number;
    cantidadRecibida: number;
  }>;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const transferenciaService = {
  getAll: async (
    page = 1,
    limit = 20,
    estado?: string,
    sucursalOrigenId?: number,
    sucursalDestinoId?: number
  ): Promise<PaginatedResponse<Transferencia>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (estado) params.append('estado', estado);
    if (sucursalOrigenId) params.append('sucursalOrigenId', sucursalOrigenId.toString());
    if (sucursalDestinoId) params.append('sucursalDestinoId', sucursalDestinoId.toString());
    
    const response = await api.get<PaginatedResponse<Transferencia>>(`/transferencias?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { transferencia: Transferencia } }> => {
    const response = await api.get<{ data: { transferencia: Transferencia } }>(`/transferencias/${id}`);
    return response.data;
  },

  create: async (data: TransferenciaCreate): Promise<{ data: { transferencia: Transferencia } }> => {
    const response = await api.post<{ data: { transferencia: Transferencia } }>('/transferencias', data);
    return response.data;
  },

  enviar: async (id: number, data: TransferenciaEnvio): Promise<{ data: { transferencia: Transferencia } }> => {
    const response = await api.post<{ data: { transferencia: Transferencia } }>(`/transferencias/${id}/enviar`, data);
    return response.data;
  },

  recibir: async (id: number, data: TransferenciaRecepcion): Promise<{ data: { transferencia: Transferencia } }> => {
    const response = await api.post<{ data: { transferencia: Transferencia } }>(`/transferencias/${id}/recibir`, data);
    return response.data;
  },

  cancelar: async (id: number): Promise<{ data: { transferencia: Transferencia } }> => {
    const response = await api.post<{ data: { transferencia: Transferencia } }>(`/transferencias/${id}/cancelar`);
    return response.data;
  }
};

